module.exports = __webpack_public_path__ + "img/ship.3c869bee.svg";